import { render, staticRenderFns } from "./sjzcyy.vue?vue&type=template&id=165ee64e&scoped=true&"
import script from "./sjzcyy.vue?vue&type=script&lang=js&"
export * from "./sjzcyy.vue?vue&type=script&lang=js&"
import style0 from "./sjzcyy.vue?vue&type=style&index=0&id=165ee64e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165ee64e",
  null
  
)

export default component.exports